export const INVITE_MEMBERS_MODAL = 'invite-members-modal';
export const SEARCH_INPUT = 'search-input';
